import React from "react";
import { Link } from "react-router-dom";
import { isEdge, isIE, isMobile } from "react-device-detect";
import unsupported from "assets/img/unsupported.svg";

import {useStakingContract, useStakingDispatch} from "../../context/StakingContract";
import {SET_TOTAL_STAKE, SET_TOTAL_STAKE_LIMIT} from "../../context/StakingContract/actions";

const Container = ({ children, title }) => (
    <div className="card">
      <div className="card-body text-center">
        <img
          src={unsupported}
          className="status my-2"
          alt="Unsupported"
        />
        <h3 className="mb-4">
          Unsupported
        </h3>
        <p className="card-text">{children}</p>
      </div>
    </div>
);

const Landing = () => {
  const {stakingContract, state} = useStakingContract();
  const dispatch = useStakingDispatch();
  const checkStakingLimits = () => {
    if (!stakingContract.stakingContract) {
      return;
    }
    stakingContract.contractTotalStakeLimit()
      .then(val => dispatch({type: SET_TOTAL_STAKE_LIMIT, payload: val}))
      .catch(err => {
        console.warn("error fetching total staking limit", err);
      });
    stakingContract.currentTotalStake()
      .then(val => {
        dispatch({type: SET_TOTAL_STAKE, payload: val})
      })
      .catch(err => {
        console.warn("error fetching total stake", err);
      });
  };
  React.useEffect(checkStakingLimits, []);

  if (isIE)
    return <Container>IE is not supported. Use Chrome/Firefox</Container>;
  if (isEdge)
    return (
      <Container>Edge is not supported. Download Chrome/Firefox</Container>
    );
  if (isMobile)
    return (
      <Container title="Mobile">
        Mobile is not supported. Please try a desktop browser
      </Container>
    );



  const percentageFilled = () => {
    const {staking} = state;
    let filled = (staking.contractTotalStake / staking.contractTotalStakeLimit) * 100;
    filled = Math.round(filled);
    if ( filled > 100 ) {
      filled = 100;
    }

    if ( isNaN(filled) ) {
      return 0;
    }

    return filled;
  };

  const {staking} = state;
  const pFilled = percentageFilled();
  return (
    <div>
      <div className="card mb-4">
        <div className="card-body">

          <div className="row">
            <div className="col-lg-3 mb-4 mb-lg-0">

              <div className={`c100 p${pFilled}`}>
                <span>{pFilled}%</span>
                <div className="slice">
                  <div className="bar"></div>
                  <div className="fill"></div>
                </div>
              </div>

            </div>
            <div className="col-lg-9 my-auto">
              <p><strong>Staking closed</strong> {/*<span class="ml-2 mb-1 badge badge-success">Completed</span>*/}<br/>
              {staking.contractTotalStake.toLocaleString('en')} ERD tokens of the {staking.contractTotalStakeLimit.toLocaleString('en')} staking cap has been filled.</p>
            </div>
          </div>

        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div class="bootstrap-alert alert alert-warning" role="alert">
            The Elrond Pre-stake process is now over, only withdrawals are allowed.{" "}<br className="d-md-none d-lg-block" /> 
            For the Genesis Staking please <a href="https://genesis.elrond.com">click here</a>.
          </div>
          <h3>Elrond Pre-staking</h3>
          <p className="lead">You're about to start staking or withdrawing your ERD (ERC20).</p>
          <p>Interaction with the staking process requires you to have <a href="https://metamask.io/" target="_blank" rel="noreferrer">MetaMask</a> installed and configured.</p>
          <p className="mb-4">In order to begin interacting with this site you will be asked to "connect" your Metamask.</p>
          <Link to="#" className={`btn btn-primary disabled ${pFilled >= 100 ? '' : ''}`}>Pre-stake</Link>
          <Link to="/withdraw" className="btn btn-secondary">Withdraw</Link>
        </div>
      </div>
    </div>
  );
};

export default Landing;